"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.descriptionHelper = void 0;
var envConfigBase_1 = require("../envConfig/envConfigBase");
var descriptionHelper = function (description) {
    if (false && (0, envConfigBase_1.envConfigBase)().environment === 'production') {
        // decided to always show class so we can follow sentry errors
        return '';
    }
    return description + ' ';
};
exports.descriptionHelper = descriptionHelper;
